import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import squadService from '../../services/squadService';
import projectService from '../../services/projectService';
import { toast } from 'react-toastify';

const SquadUpdate = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    squad_code: '',
    project_id: '',
    organization_id: '',
    status: 'Active',
  });

  useEffect(() => {
    fetchProjects();
    fetchSquad();
  }, [id]);

  const fetchProjects = async () => {
    try {
      const data = await projectService.getAllProjects();
      setProjects(data.projects || []);
    } catch (err) {
      console.error('Failed to fetch projects:', err);
    }
  };


  const fetchSquad = async () => {
    try {
      setFetching(true);
      setError(null);

      const data = await squadService.getAllsquads();
      const squad = (data.squads || []).find((s) => s.id === id);

      if (!squad) {
        setError('Squad not found');
        return;
      }

      setFormData({
        name: squad.name || '',
        squad_code: squad.squad_code || '',
        project_id: squad.project_id || '',
        organization_id: squad.organization_id || '',
        status: squad.status || 'Active',
      });
    } catch (err) {
      setError('Failed to fetch squad');
      console.error('Error fetching squad:', err);
    } finally {
      setFetching(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await squadService.updatesquads(id, formData);
      toast.success(response?.message || 'Squad updated successfully');
      navigate('/app/squads');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update squad');
      toast.error(
        err.response?.data?.error ||
          err.response?.data?.message ||
          'Failed to update squad'
      );
      console.error('Error updating squad:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/app/squads');
  };

  if (fetching) {
    return <div className="loading">Loading Squad...</div>;
  }

  return (
    <div className="milestone-form-container">
      <div className="milestone-form-header">
        <h2>Edit Squad</h2>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <form onSubmit={handleSubmit} className="milestone-form">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 mb-4">
          <div className="form-group">
            <label htmlFor="name">Squad Name *</label>
            <input
              type="text"
              id="name"
              name="name"
            //   disabled
              value={formData.name}
              onChange={handleChange}
              className="form-control"
              required
              placeholder="Enter squad name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="squad_code">Squad Code *</label>
            <input
              type="text"
            //   disabled
              id="squad_code"
              name="squad_code"
              value={formData.squad_code}
              onChange={handleChange}
              className="form-control"
              required
              placeholder="e.g. SQD-15"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
          <div className="form-group">
            <label htmlFor="project_id">Project *</label>
            <select
              id="project_id"
              name="project_id"
              disabled
              value={formData.project_id}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="">Select Project</option>
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name} ({project.code})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="status">Status *</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="form-control"
              required
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={handleCancel}
            className="btn btn-secondary"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Update Squad'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SquadUpdate;